import { Icon } from '@fm-nx/svg';

/* eslint-disable-next-line */
export interface SocialIconsProps {
    color?: 'white' | 'black';
}

export function SocialIcons(props: SocialIconsProps) {
    const { color = 'black' } = props;

    return (
        <ul className="flex flex-wrap items-center justify-between space-x-6 md:justify-start">
            {/*<li className="w-6 h-6 mb-4">*/}
            {/*    <a href="https://www.facebook.com/fostermade" className="group">*/}
            {/*        <span className="sr-only">Facebook</span>*/}
            {/*        <Icon name="facebook" color={color} />*/}
            {/*    </a>*/}
            {/*</li>*/}
            {/*<li className="w-6 h-6 mb-4">*/}
            {/*    <a href="https://www.instagram.com/fostermadeco/" className="group">*/}
            {/*        <span className="sr-only">Instagram</span>*/}
            {/*        <Icon name="instagram" color={color} />*/}
            {/*    </a>*/}
            {/*</li>*/}
            {/*<li className="w-6 h-6 mb-4">*/}
            {/*    <a href="#" className="group">*/}
            {/*        <span className="sr-only">Threads</span>*/}
            {/*        <Icon name="threads" color={color} />*/}
            {/*    </a>*/}
            {/*</li>*/}
            {/*<li className="w-6 h-6 mb-4">*/}
            {/*    <a href="https://twitter.com/fostermadeco" className="group">*/}
            {/*        <span className="sr-only">Twitter</span>*/}
            {/*        <Icon name="twitter" color={color} />*/}
            {/*    </a>*/}
            {/*</li>*/}
            {/*<li className="w-6 h-6 mb-4">*/}
            {/*    <a href="https://dribbble.com/fostermade" className="group">*/}
            {/*        <Icon color={color} name="dribbble" />*/}
            {/*        <span className="sr-only">Dribbble</span>*/}
            {/*    </a>*/}
            {/*</li>*/}
            <li className="w-6 h-6 mb-4">
                <a href="https://www.linkedin.com/company/foster-made/" className="group">
                    <span className="sr-only">LinkedIn</span>
                    <Icon color={color} name="linkedin" />
                </a>
            </li>
            <li className="w-6 h-6 mb-4">
                <a href="https://www.github.com/fostermadeco" className="group">
                    <span className="sr-only">Github</span>
                    <Icon color={color} name="github" />
                </a>
            </li>
        </ul>
    );
}

export default SocialIcons;
